module.exports = __webpack_public_path__ + "static/media/savoy.e7e1ef2c.webp";